import React from 'react';
import { IProps } from './types';
import Modal from 'components/Modal';
import { RootReducersState } from 'redux/reducers';
import { Dispatch } from 'redux';
import { setConfirmModalVisibleAction } from 'redux/actions/modal.action';
import { connect } from 'react-redux';
import departHomeIcon from 'assets/images/depart-home.svg';
import travelingIcon from 'assets/images/traveling.svg';
import returnHomeIcon from 'assets/images/return-home.svg';
import moment from 'moment-timezone';

const ConfirmModal: React.FC<IProps> = props => {
  const datePickerElement = document.querySelector('[data-fieldname=START_DATE]') as HTMLElement;
  const startDate = moment(props.formValues.START_DATE).format('YYYY-MM-DD 00:00:00');
  const endDate = moment(props.formValues.END_DATE).format('YYYY-MM-DD 00:00:00');
  const period = moment(endDate).diff(moment(startDate), 'd');

  const handleConfirm = () => {
    props.setConfirmModalVisible(false);
    props.onConfirm();
  };

  const handleCancel = () => {
    props.setConfirmModalVisible(false);
    datePickerElement.focus();
  };

  return (
    <>
      {props.modal.confirmModalVisible && (
        <div className="confirm-modal">
          <Modal
            visible={props.modal.confirmModalVisible}
            confirmButton={false}
            cancelButton={false}
            title={props.title}
            overlayDismiss={false}
            closeIcon={false}
          >
            <span className="modal__subtitle">請確認以下投保資料是否正確</span>
            <div className="insured-data__container">
              <div className="insured-data__item">
                <p>旅遊地點</p>
                <p>{props.tempTravels.map(item => item.COUNTRY_NAME).join('、')}</p>
              </div>
              <div className="insured-data__item">
                <p>保險期間</p>
                <p>
                  {moment(props.formValues.START_DATE).format('YYYY/MM/DD')}&nbsp;{moment(props.formValues.INSURED_TIME).format('HH') + ':00 ~ '}
                  {moment(props.formValues.END_DATE).format('YYYY/MM/DD')}&nbsp;{moment(props.formValues.INSURED_TIME).format('HH') + ':00'}
                </p>
              </div>
              <div className="insured-data__item">
                <p>投保天數</p>
                <p>{period}天</p>
              </div>
            </div>
            <div className="reminder__container">
              <div className="reminder__icon-container">
                <div className="reminder__icon-item">
                  <img src={departHomeIcon} alt="depart from home" />
                  <p>住家出發</p>
                </div>
                <span className="reminder__arrow">---{'>'}</span>
                <div className="reminder__icon-item">
                  <img src={travelingIcon} alt="traveling" />
                  <p>旅途中</p>
                </div>
                <span className="reminder__arrow">---{'>'}</span>
                <div className="reminder__icon-item">
                  <img src={returnHomeIcon} alt="return home" />
                  <p>返抵住家</p>
                </div>
              </div>
              <div className="reminder__content">
                <p>建議保險期間涵蓋</p>
                <p>「從住家出發<span>-{'>'}</span>旅途中<span>-{'>'}</span>回國返抵住家止」</p>
                <p>讓您的旅途全程享有完整保障。</p>
              </div>
            </div>
            <div className="modal__button-group">
              <button type="button" onClick={handleCancel} className="button element__button--black">返回修改</button>
              <button type="button" onClick={handleConfirm} className="button element__button--red">確認投保</button>
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setConfirmModalVisible: (visible: boolean) => dispatch(setConfirmModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmModal);
